<div class="dense-1" style="width: 100%;font-size: 10px;" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">
  <mat-form-field  class="dense-1" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" appearance="outline" [formGroup]="group">
    <mat-label>{{field.label}}
      @if (isRequired(field.name)) {
        <span class="required-symbol">*</span>
      }
    </mat-label>
    <input matInput [formControlName]="field.name" [type]="field.inputType">

    <!-- Updated mat-error with null check -->
    @for (validation of field['dynamicFormLabelValidator']; track validation) {
      <ng-container ngProjectAs="mat-error">
        @if (group.get(field.name) && group.get(field.name).hasError(validation.name)) {
          <mat-error>
            {{validation.message}}
          </mat-error>
        }
      </ng-container>
    }

    @for (validation of field['dynamicFormLabelValidator']; track validation) {
      <mat-hint [align]="start">
        {{validation.hintMessage}}
      </mat-hint>
    }

  </mat-form-field>

  @if (customField13 == 1) {
    <button mat-raised-button
      style="margin: 0px 10px; border-radius: 12px; height: 57px; padding: 0 30px; font-size: 16px; font-weight: bold; color: white; background-color: #3f51b5; transition: background-color 0.3s ease, box-shadow 0.3s ease;"
      color="primary"
      (click)="setValue(group.get(field.name).value)"
      (mouseover)="hover = true"
      (mouseleave)="hover = false"
      [style.boxShadow]="hover ? '0 8px 16px rgba(0, 0, 0, 0.2)' : 'none'"
      [style.backgroundColor]="hover ? '#2c3e9a' : '#3f51b5'"
      >
      Submit
    </button>
  }

</div>

